import React, { Component } from 'react';
import { Notifications } from '$components/account';
import { currentAgentSelector, formSelector } from '$selectors';
import { connect } from 'react-redux';
import { update, fetchCurrent } from '$actions/agents';
import timeZones from '$constants/time-zones.json';
import languages from '$constants/languages.json';

@connect(state => ({
  agent: currentAgentSelector(state),
  form: formSelector(state, 'agentUpdate')
}), { update, fetchCurrent })
export default class NotificationsRoute extends Component {
  componentWillMount() {
    this.props.fetchCurrent();
  }

  render() {
    const { agent, update, form } = this.props;

    if (!agent) return <div></div>;

    return (
      <Notifications
        account={agent}
        errors={form.errors}
        success={form.success}
        onSubmit={update}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/routes/account/notifications.js